












import { Component, Emit, Prop, Vue, } from 'vue-property-decorator';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';

@Component({
  components: {
    AutoCreateForm
  }
})

export default class HeaderPanel extends Vue {
  @Prop({ default: () => ([]) })
  private fieldData: any;
  @Prop({ default: '' })
  private fieldCols: any;

  @Emit('catchInput')
  private catchInput(response: any) {
    return response;
  }
}
